(() => {
  const dialog = document.getElementById("MarketSelectorDialog");
  if (!dialog || dialog.dataset.initialized === "true") return;

  dialog.dataset.initialized = "true";
  let returnFocus = null;

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-market-selector-open]");
    if (!trigger) return;

    returnFocus = trigger;
    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
  });

  const closeDialog = () => {
    if (typeof dialog.close === "function") dialog.close();
    else dialog.removeAttribute("open");
  };

  const closeButton = dialog.querySelector("[data-market-selector-close]");
  if (closeButton) closeButton.addEventListener("click", closeDialog);
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) closeDialog();
  });
  dialog.addEventListener("close", () => {
    if (returnFocus) returnFocus.focus();
  });

  const suggestion = document.querySelector("[data-market-suggestion]");
  const currentCountry = dialog.dataset.currentCountry;
  if (!suggestion || !currentCountry) return;

  const loadSuggestion = async () => {
    try {
      const root = window.Shopify?.routes?.root || "/";
      const endpoint = `${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(currentCountry)}`;
      const response = await fetch(endpoint, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return;

      const payload = await response.json();
      const country = payload?.suggestions?.[0]?.parts?.country;
      const suggestedCode = country?.handle;
      if (!suggestedCode || suggestedCode === currentCountry) return;

      const dismissalKey = `lunarness-market-suggestion-${suggestedCode}`;
      if (window.sessionStorage?.getItem(dismissalKey) === "dismissed") return;

      const input = suggestion.querySelector("[data-market-suggestion-country]");
      const copy = suggestion.querySelector("[data-market-suggestion-copy]");
      const dismiss = suggestion.querySelector("[data-market-suggestion-dismiss]");
      if (!input || !copy || !dismiss) return;

      input.value = suggestedCode;
      copy.textContent = (copy.dataset.marketSuggestionTemplate || "").replace(
        "__COUNTRY__",
        country.name || suggestedCode,
      );
      suggestion.hidden = false;

      dismiss.addEventListener("click", () => {
        suggestion.hidden = true;
        window.sessionStorage?.setItem(dismissalKey, "dismissed");
      }, { once: true });
    } catch (_error) {
      // Country detection is an enhancement; the manual selector remains available.
    }
  };

  if ("requestIdleCallback" in window) window.requestIdleCallback(loadSuggestion, { timeout: 1800 });
  else window.setTimeout(loadSuggestion, 600);
})();
